import React from 'react';
import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from "react-redux";
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from 'react-responsive'
import { useSearchProductsListQuery } from '../../services/search';
import IconButton from '@mui/joy/IconButton';
import ProductCountries from '../../Components/Header/ProductCountries';
import formatPrice from '../../Components/formatPrice';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import GradeIcon from '@mui/icons-material/Grade';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import Skeleton from '@material-ui/lab/Skeleton';
const Root = styled('div')(({ theme }) => ({
  width: '100%',
  ...theme.typography.body2,
  color: (theme.vars || theme).palette.text.secondary,
  '& > :not(style) ~ :not(style)': {
    marginTop: theme.spacing(2),
  },
}));

var moment = require('moment');
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
  },
  item: {
    scrollSnapAlign: 'start',
  },
  imageList: {
    "&::-webkit-scrollbar": {
      display: "none"
    }, /* Chrome */
    scrollSnapType: 'x mandatory',
    flexWrap: 'nowrap',
    margin: '0px !important',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  title: {
    color: theme.palette.primary.light,
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
}));

function DbSearchResults({ userData }) {
  const { userId, userToken, userEmail, languageCode, countryCode } = useSelector((state) => state.auth);
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { query } = useParams();

  const limit = new URLSearchParams(location.search).get('size') || 48
  const searchCountry = new URLSearchParams(location.search).get('country') || null
  const thisCountry = searchCountry ? `&search_country=${searchCountry}` : ''
  const isMobcreen2 = useMediaQuery({ query: '(min-width: 0px) and (max-width: 992px)' })
  const isMobcreen = useMediaQuery({ query: '(min-width: 0px) and (max-width: 768px)' })
  const isMobcreenA = useMediaQuery({ query: '(min-width: 768px) and (max-width: 1240px)' })

  const { data: localData, isLoading: localLoading, isError: localError, isFetching: localFetching } = useSearchProductsListQuery({
    size: limit,
    query: query,
    countryCode: countryCode,
    searchCountry: thisCountry
  }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const localSearchData = localData?.results

  const listRef = React.useRef(null);
  const handleScroll = (direction) => {
    if (listRef.current) {
      const itemWidth = listRef.current.scrollWidth / localSearchData?.length;
      listRef.current.scrollBy({
        left: direction === 'next' ? itemWidth * 4 : -itemWidth * 4,
        behavior: 'smooth',
      });
    }
  };

  function localLoadFetch(loading, fetching) {
    if (loading) {
      return true
    } else if (fetching) {
      return true
    } else {
      return false
    }
  }

  function getDeliverydays(delivery) {
    const deliveryDaya = Number(delivery) + Number(userData?.contant?.delivery_days || 0)
    function getTimeline() {
      if (Number(deliveryDaya) === 1) {
        return <>{t('delivery_by')} <strong>Tomorrow</strong> {moment().add(Number(deliveryDaya), 'days').format('Do')}</>
      } else {
        return <>{t('delivery_by')} {moment().add(Number(deliveryDaya), 'days').format('Do MMM')}</>
      }
    }
    if (Number(deliveryDaya) > 0) {
      return getTimeline()
    } else {
      return `${t('delivery_by')} ${moment().add(10, 'days').format('Do MMM')}`
    }
  }

  function productTitle(title) {
    return title?.replace(/[^A-Za-z0-9]/g, ' ')?.replace(/[^\w\s]/gi, ' ')?.replace(/ /g, '-')
  }


  const handleError = (e) => {
    console.error('Error loading image:', e.target.src);
    e.target.src = 'https://cdn.ebtida.com/1705315901965-Image-not-found.jpg';
  };

  const beforeLoadHandler = () => (
    <img
      className="img-item"
      src='https://cdn.ebtida.com/1705315901965-Image-not-found.jpg' />
  );

  function ratingFucn(rating) {
    if (rating === 0) {
      return false
    } else if (rating === '0') {
      return false
    } else if (!rating) {
      return false
    } else {
      return true
    }
  }

  const storIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12]

  function functionIdLink(id, pid, store_id) {
    if (storIds?.includes(Number(store_id))) {
      return pid
    } else {
      return id
    }
  }

  function checkIfAnyNumber(badge) {
    return /\d|×/.test(badge)
  }

  function loadCountrySkeleton(fetch, country, itemCountry) {
    if (!country) {
      return false
    }
    if (fetch && country != itemCountry) {
      return true
    }
    if (fetch && !country) {
      return true
    }
    return false
  }

  return (
    <>
      {localLoading ?
        '' :
        <>

          {localSearchData?.length > 0 &&
            <div className="col-md-12" style={{ padding: '5px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                <div style={{ padding: '0px 5px 0px 5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <Root>
                      <Divider className='border-divider'
                      // textAlign="left"
                      >
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '0.95rem', fontWeight: 500, color: '#2f122e' }}>
                            {t('Quick Results')}
                          </span>
                        </span>
                      </Divider>
                    </Root>
                  </div>
                </div>
              </div>
            </div>
          }

          {localSearchData?.length > 0 &&
            <div className="col-md-12" style={{ padding: '5px' }}>
              <div style={{ position: 'relative' }}>
                {localSearchData?.length > 5 &&
                  <>
                    <div className='scroll-back_cards-search'>
                      <IconButton
                        style={{ display: 'flex', alignItems: 'center', background: '#fcfcfc', borderRadius: '100px' }}
                        variant='outlined'
                        size='md'
                        onClick={() => handleScroll('prev')}
                        disabled={false}>
                        <svg width="17" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                        </svg>
                      </IconButton>
                    </div>
                    <div className='scroll-next_cards-search'>
                      <IconButton
                        style={{ display: 'flex', alignItems: 'center', background: '#fcfcfc', borderRadius: '100px' }}
                        variant='outlined'
                        size='md'
                        onClick={() => handleScroll('next')}
                        disabled={false}>
                        <svg width="17" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                        </svg>
                      </IconButton>
                    </div>
                  </>
                }
                <ImageList
                  ref={listRef}
                  style={{ margin: 0, position: 'relative' }}
                  className={classes.imageList}
                  cols={isMobcreenA ? 3.5 : isMobcreen ? 1.4 : 5}>
                  {localSearchData?.map((item, i) =>
                    <ImageListItem className="cardItem fd-carousel" key={i} style={{ maxWidth: 'none', flex: 'none', height: 'auto', position: 'relative', padding: '5px' }}>

                      <Link
                        style={{ position: 'relative' }}
                        className="cardItem-item"
                        to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}>

                        {checkIfAnyNumber(item.deal_badge) ? '' :
                          item.deal_badge &&
                          <div className='deal--badge--'>{item.deal_badge}</div>
                        }
                        <div className="img-card imgCard" style={{ height: isMobcreen2 ? '125px' : '175px' }}>
                          {localFetching && !searchCountry ?
                            <Skeleton className='img-item' variant="rect" style={{ width: '100%', height: '100%', height: isMobcreen2 ? '125px' : '175px', marginBottom: '10px' }} /> :
                            <LazyLoadImage
                              style={{ height: isMobcreen2 ? '125px' : '175px' }}
                              delayTime={100}
                              key={i}
                              alt={item?.title}
                              effect="blur"
                              className="img-item"
                              src={item?.image}
                              onError={handleError}
                              beforeLoad={beforeLoadHandler}
                            />
                          }
                          <div className={`delivery-days`}>
                            {localFetching && !searchCountry ?
                              '' :
                              <span style={{ padding: 0 }} className={isMobcreen ? `badge badge-secondary` : ``}>
                                {getDeliverydays(item.estimated_delivery)}
                              </span>
                            }
                          </div>
                          {item?.prices?.deal_value &&
                            <span
                              className='badge badge-danger'
                              style={{ position: 'absolute', left: '5px', top: '5px', zIndex: 111, width: 'auto' }}>
                              <FlashOnIcon style={{ fontSize: '1rem' }} />
                            </span>
                          }
                        </div>
                        <div className="card-content" style={{ height: '90px' }}>
                          <div className='title-card' style={{ maxHeight: '24px', minHeight: '24px' }}>
                            {localFetching && !searchCountry ?
                              <Skeleton style={{ height: '18px', width: '100%' }} /> :
                              <div className='dbs-title'>{item?.title?.replace(/[^\w\s.,'/:]/gi, ' ')}</div>
                            }
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {localFetching && !searchCountry ?
                              <Skeleton style={{ height: '18px', width: '50%' }} /> :
                              item?.brand && <div className='brand' style={{ width: '100%' }}>{item?.brand}</div>}
                            {ratingFucn(item?.rating) &&
                              <div className='rating' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
                                <span style={{ display: 'flex', alignItems: 'center', color: '#575959', margin: '0px 3px', fontSize: '14px' }}>{item?.rating}</span>
                                <GradeIcon style={{ color: '#fe7f4a', fontSize: '1rem', marginTop: '-1.5px' }} />
                              </div>
                            }
                          </div>
                          <div className="content-item" style={{ padding: 0 }}>
                            <div className='item-price-card' style={{ justifyContent: 'space-between', width: '100%' }}>
                              {localFetching && !searchCountry ?
                                <Skeleton style={{ height: '18px', width: '50%' }} /> :
                                Number(item?.prices?.value) === 0 ?
                                  <span className='badge badge-secondary'>Check Price</span>
                                  :
                                  <>
                                    {item?.in_stock ?
                                      <>
                                        <span className='item-deal-price'>
                                          <div style={{ lineHeight: 1.2 }}>
                                            {formatPrice(item?.prices?.value, item?.prices?.currency, 0)}&nbsp;
                                          </div>
                                        </span>
                                        {item?.prices?.deal_value &&
                                          <span className='item-price' style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                            <small style={{ textDecoration: 'line-through', color: '#828282' }}>
                                              {formatPrice(item?.prices?.price, item?.prices?.currency, 0)}
                                            </small>
                                            {/* {item?.prices?.discount ?
                                            <span className='badge badge-danger'>
                                              {`-${item?.prices?.discount}%`}
                                            </span> : ``
                                          } */}
                                          </span>
                                        }
                                      </> : ''
                                    }
                                  </>
                              }
                              {loadCountrySkeleton(localFetching, searchCountry, item?.country) ?
                                <Skeleton style={{ height: '22px', width: '30%' }} /> :
                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '3px' }}>
                                  <div style={{ fontSize: '0.7rem', lineHeight: 0, color: '#575959' }}>
                                    {t('from')}
                                  </div>
                                  <img
                                    style={{ width: '20px', objectFit: 'contain' }}
                                    loading="lazy"
                                    src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                                    srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                                    alt=""
                                  />
                                  <div style={{ fontSize: '0.7rem', lineHeight: 0, color: '#575959' }}>
                                    {ProductCountries(item?.country)}
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </Link>
                    </ImageListItem>
                  )}
                </ImageList>
              </div>
            </div>
          }
        </>
      }
    </>
  )

};

export default DbSearchResults;